if (!window.Eurus.loadedScript.includes('lp-rezero.js')) {
    window.Eurus.loadedScript.push('lp-rezero.js');
}
const deferScriptLoad = (name, src, onload, requestVisualChange = false) => {
    window.Eurus.loadedScript.push(name);
    (events => {
        const loadScript = () => {
            events.forEach(type => window.removeEventListener(type, loadScript));
            clearTimeout(autoloadScript);
            const initScript = () => {
                const script = document.createElement('script');
                script.setAttribute('src', src);
                script.setAttribute('defer', '');
                script.onload = () => {
                    document.dispatchEvent(new CustomEvent(name + ' loaded'));
                    onload();
                };
                document.head.appendChild(script);
            };
            if (requestVisualChange) {
                if (window.requestIdleCallback) {
                    requestIdleCallback(initScript);
                }
                else {
                    requestAnimationFrame(initScript);
                }
            }
            else {
                initScript();
            }
        };
        let autoloadScript;
        const wait = window.innerWidth > 767 ? 2000 : 5000;
        events.forEach(type => window.addEventListener(type, loadScript, { once: true, passive: true }));
        autoloadScript = setTimeout(() => {
            loadScript();
        }, wait);
    })(['touchstart', 'mouseover', 'wheel', 'scroll', 'keydown']);
};
// alpine func
requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
        // global vars
        Alpine.store('global', {
            headerHeight: 90,
            sticky: false,
            stickyTrigger: {
                ['x-intersect:enter.full']: '$store.global.sticky = false',
                ['x-intersect:leave.full']: '$store.global.sticky = true'
            },
            mobileNav: false,
            toggleNav() {
                this.mobileNav = !this.mobileNav;
            },
            closeNav() {
                this.mobileNav = false;
            }
        }),
            // toggle data
            Alpine.data('lpToggle', () => ({
                open: false,
                toggleDetails: {
                    ['x-effect']: "$el.toggleAttribute('open', open)"
                },
                toggleBtn: {
                    ['@click.prevent']: "open = ! open; !open && $el.parentElement.getBoundingClientRect().y - $store.global.headerHeight < 0 && scrollTo({ top: Math.floor($el.parentElement.getBoundingClientRect().y + window.scrollY - $store.global.headerHeight) , behavior: 'instant' })",
                    [':aria-expanded']: "open ? 'true' : 'false'",
                    [':class']: "open && 'sticky top-27 z-2 shadow-lg'"
                },
                btnLabel: {
                    ['x-effect']: "open ? $el.textContent = 'Close' : $el.textContent = 'View more'"
                },
                btnGraphic: {
                    [':class']: "open && 'rotate-180'"
                },
                toggleContent: {
                    ['x-show']: "open",
                    ['x-transition:enter.opacity.duration.500ms']: ""
                },
            })),
            Alpine.data('lpHeader', () => ({
                headerBind: {
                    ['x-init']: "$store.global.headerHeight = $el.getBoundingClientRect().height + 10",
                    [':class']: `$store.global.sticky && !($store.global.mobileNav) && 'shadow-md'`,
                    ['@resize.window.throttle']: "$store.global.headerHeight = $el.getBoundingClientRect().height + 10"
                },
                logos: {
                    [':class']: `$store.global.sticky ? 'md:max-w-80' : 'md:max-w-100'`,
                },
                navItem: {
                    ['@click.prevent']: "scrollTo({ top: Math.floor(document.querySelector($el.getAttribute('href')).offsetTop - $store.global.headerHeight) , behavior: 'auto' });"
                },
                navItemMobile: {
                    ['@click.prevent']: "scrollTo({ top: Math.floor(document.querySelector($el.getAttribute('href')).offsetTop - $store.global.headerHeight) , behavior: 'auto' }); $store.global.closeNav();"
                },
                navDetails: {
                    ['x-effect']: "$el.toggleAttribute('open', $store.global.mobileNav)"
                },
                navBtn: {
                    ['@click.prevent']: "$store.global.toggleNav()",
                    [':aria-expanded']: "$store.global.mobileNav ? 'true' : 'false'"
                },
                mobileNav: {
                    ['x-show']: "$store.global.mobileNav",
                    ['x-transition.opacity']: ""
                },
                navHamburger: {
                    ['x-show']: "!$store.global.mobileNav"
                },
                navClose: {
                    ['x-show']: "$store.global.mobileNav"
                },
            })),
            Alpine.data('shirt', () => ({
                shirt: '',
                shirtWhite: {
                    [':class']: "shirt == 'white' || 'opacity-0'",
                    [':aria-hidden']: "shirt == 'white' ? false : true"
                },
                shirtBlack: {
                    [':class']: "shirt == 'black' || 'opacity-0'",
                    [':aria-hidden']: "shirt == 'black' ? false : true"
                },
                swatchBlack: {
                    ['@click']() { this.shirt = 'black'; }
                },
                swatchWhite: {
                    ['@click']() { this.shirt = 'white'; },
                },
            })),
            // splide
            Alpine.store('xSplide', {
                load(el, configs) {
                    const initSlider = () => {
                        const id = el.getAttribute("id");
                        if (configs.classes != undefined) {
                            if (!configs.classes.arrow)
                                configs.classes.arrow = "arrow w-8 h-8 p-2 absolute z-10 top-1/2 -translate-y-1/2 hidden md:flex items-center justify-center";
                            if (!configs.classes.next)
                                configs.classes.next = "right-0";
                            if (!configs.classes.prev)
                                configs.classes.prev = "-rotate-180";
                        }
                        let splide = new Splide("#" + id, configs);
                        if (configs.thumbs) {
                            let thumbsRoot = document.getElementById(configs.thumbs);
                            let thumbs = thumbsRoot.getElementsByClassName('x-thumbnail');
                            let current;
                            let _this = this;
                            for (let i = 0; i < thumbs.length; i++) {
                                if (thumbs[i] == current) {
                                    thumbs[i].classList.remove('opacity-30');
                                }
                                else {
                                    thumbs[i].classList.add('opacity-30');
                                }
                                thumbs[i].addEventListener('click', function () {
                                    _this.moveThumbnail(i, thumbs[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                                    splide.go(i);
                                });
                            }
                            splide.on('refresh', function () {
                                for (let i = 0; i < thumbs.length; i++) {
                                    thumbs[i].removeEventListener('click', function () {
                                        _this.moveThumbnail(i, thumbs[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                                        splide.go(i);
                                    });
                                }
                                let thumbsRoot = document.getElementById(configs.thumbs);
                                let thumbsNew = thumbsRoot.getElementsByClassName('x-thumbnail');
                                for (let i = 0; i < thumbsNew.length; i++) {
                                    if (i == 0) {
                                        thumbsNew[i].classList.remove('opacity-30');
                                    }
                                    else {
                                        thumbsNew[i].classList.add('opacity-30');
                                    }
                                    thumbsNew[i].addEventListener('click', function () {
                                        _this.moveThumbnail(i, thumbsNew[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                                        splide.go(i);
                                    });
                                }
                            });
                            splide.on('mounted move', function () {
                                let thumbnail = thumbs[splide.index];
                                if (thumbnail) {
                                    if (current) {
                                        current.classList.add('opacity-30');
                                    }
                                    thumbnail.classList.remove('opacity-30');
                                    current = thumbnail;
                                    _this.moveThumbnail(splide.index, thumbnail, thumbsRoot, configs.thumbs_direction, configs.direction);
                                }
                            });
                        }
                        if (configs.hotspot) {
                            let hotspotRoot = document.getElementById(configs.hotspot);
                            let hotspots = hotspotRoot.getElementsByClassName('x-hotspot');
                            let current;
                            if (configs.disableHoverOnTouch && (('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints)) {
                                for (let i = 0; i < hotspots.length; i++) {
                                    hotspots[i].addEventListener('click', function () {
                                        splide.go(i);
                                    });
                                }
                            }
                            else {
                                for (let i = 0; i < hotspots.length; i++) {
                                    hotspots[i].addEventListener('mouseover', function () {
                                        splide.go(i);
                                    });
                                    hotspots[i].addEventListener('focus', function () {
                                        splide.go(i);
                                    });
                                }
                            }
                            splide.on('mounted move', function () {
                                let hotspot = hotspots[splide.index];
                                if (hotspot) {
                                    if (current) {
                                        current.classList.remove('active-hotspot');
                                    }
                                    hotspot.classList.add('active-hotspot');
                                    current = hotspot;
                                }
                            });
                        }
                        if (configs.cardHover) {
                            let cardImage = document.getElementById(configs.cardHover);
                            if (window.innerWidth > 1024) {
                                cardImage.addEventListener('mousemove', function (e) {
                                    let left = e.offsetX;
                                    let width = cardImage.getBoundingClientRect().width;
                                    let spacing = left / width;
                                    let index = Math.floor(spacing * configs.maxSlide);
                                    splide.go(index);
                                });
                                cardImage.addEventListener('mouseleave', function (e) {
                                    splide.go(0);
                                });
                            }
                        }
                        if (configs.progressBar) {
                            var bar = splide.root.querySelector('.splide-progress-bar');
                            splide.on('mounted move', function () {
                                var end = configs.progressBar;
                                if (configs.progressBarHeader) {
                                    end = splide.Components.Slides.getLength();
                                }
                                var rate = 100 * (splide.index / end);
                                if (bar) {
                                    var widthBar = window.getComputedStyle(bar).getPropertyValue('width').replace("px", '');
                                    var widthProgressBar = window.getComputedStyle(bar.closest('.splide-progress')).getPropertyValue('width').replace("px", '');
                                    var percentBar = 100 * (Number(widthBar) / Number(widthProgressBar));
                                    var rateBar = rate + percentBar;
                                    var maxRate = 100 - percentBar;
                                    if (rateBar > 100) {
                                        rate = maxRate;
                                    }
                                    if (document.querySelector('body').classList.contains('rtl')) {
                                        bar.style.marginRight = rate + '%';
                                    }
                                    else {
                                        bar.style.marginLeft = rate + '%';
                                    }
                                }
                            });
                        }
                        if (el.classList.contains('card-product-img')) {
                            splide.on('resized', function () {
                                var height = splide.root.querySelector('.splide__track').offsetHeight;
                                splide.Components.Slides.get().forEach((item) => {
                                    item.slide.style.height = height + "px";
                                });
                            });
                        }
                        if (configs.events) {
                            configs.events.forEach((e) => {
                                splide.on(e.event, e.callback);
                            });
                        }
                        el.splide = splide;
                        splide.mount();
                        if (configs.playOnHover) {
                            splide.Components.Autoplay.pause();
                            el.onmouseover = function () {
                                splide.Components.Autoplay.play();
                            };
                            el.onmouseout = function () {
                                splide.Components.Autoplay.pause();
                            };
                        }
                    };
                    if (!window.Eurus.loadedScript.includes('slider')) {
                        deferScriptLoad('slider', window.Eurus.sliderScript, initSlider, true);
                    }
                    else if (window.Splide) {
                        initSlider();
                    }
                    else {
                        document.addEventListener('slider loaded', () => {
                            initSlider();
                        });
                    }
                },
                moveThumbnail(index, thumbnail, thumbsRoot, direction) {
                    if (thumbnail) {
                        if (direction == 'vertical') {
                            setTimeout(() => {
                                thumbsRoot.scrollTop = (index + 1) * thumbnail.offsetHeight - thumbsRoot.offsetHeight * 0.5 + thumbnail.offsetHeight * 0.5 + index * 12;
                            }, 50);
                        }
                        else {
                            thumbsRoot.scrollLeft = (index - 2) * thumbnail.offsetWidth;
                        }
                    }
                }
            });
    });
});
